export default function extractIds(values) {
  return values.map((item) => item.value);
}
